module.exports = __webpack_public_path__ + "static/img/index-slogan-cn.7cd912f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index-slogan-cn.png
// module id = AkTQ
// module chunks = 1